import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";
//UI
import logo from '../icons/logo.png'
import ShowPassword from '../../components/ShowPassword';
//TRASLATION
import { useTranslation } from "react-i18next";
//ACTIONS
import { changePasswordUser } from '../../redux/actions/catalogs/user/changePasswordUser';
import { FaCheck } from 'react-icons/fa';
import { FaCircleCheck } from 'react-icons/fa6';

const ChangePasswordForm = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const { t } = useTranslation();
  let { user_id } = useParams();
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
  const { getValues, register, handleSubmit, errors } = useForm();
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const [isPasswordConfirmHidden, setIsPasswordConfirmHidden] = useState(true);
  const [comparePass, setComparePass] = useState(true)
  const userState = useSelector(state => state.userReducer)

  const onSubmit = (data) => {
    if (data.password === data.confirmPassword) {
      dispatch(changePasswordUser(user_id, data));
    }
  };

  function comparePassword() {
    if (getValues("password") !== getValues("confirmPassword")) {
      setComparePass(false)
    } else {
      setComparePass(true)
    }
  }

  const handleNavigate = (path) => {
    history.push(path)
  }

  return (
    <div
      className={`text-sky-800 flex justify-center items-center 2xl:items-center transition-all h-full w-full min-h-screen bg-cover bg-center bg-[url('../src/containers/icons/Picture3.jpg')]`}
    >
      <div className="absolute top-0 left-0 w-full h-full bg-gray-600/40 backdrop-blur-sm"></div>
      <div className="w-[90%] h-full transition-all fle rounded-md sm:w-2/3 md:w-[35%]  bg-[#ffffff6a] sm:bg-[#ffffff6a] backdrop-blur-lg shadow-lg shadow-gray-500 flex flex-col items-center justify-center">
        {userState.message === "password updated successfully" ?
          <>
            <div className='flex p-2 w-[80%] border-green-500 rounded-md border mt-6 bg-green-200 h-[100px] items-center justify-center gap-4 flex-row'>
              <FaCircleCheck className='text-green-600 text-3xl' />
              <div className='flex flex-col'>
                <h1 className="text-left text-lg mb-0">{t("change_password_success")}</h1>
                <p className='mb-0'>{t("change_password_success_message")}</p>
              </div>
            </div>
            <div className='flex w-full justify-center h-[35px] my-5'>
              <button onClick={() => handleNavigate('/login')} type="button" className="btn shadow-lg btn-block w-[70%] bg-gray-500 hover:bg-gray-400 hover:duration-300 hover:textwhite border-none rounded-md text-white flex justify-center items-center gap-2">
                Iniciar sesión
              </button>
            </div>
          </>
          :
          <form onSubmit={handleSubmit(onSubmit)} className="w-[75%] text-gray-800 mx-auto mb-8">
            <div className='flex flex-col gap-2 w-[65%] mt-14'>
              <h1 className="text-center text-[18px] font-semibold ">{t("change_password_title")}</h1>
            </div>
            <div className='flex flex-col p-2 w-full text-sky-700 border-green-500 rounded-md border mt-6 bg-green-200'>
              <h1 className="text-left text-sm mb-0">{t("change_password_instructions")}</h1>
              <div className='pl-2 text-sm'>
                <p className='mb-0'>- {t("change_password_instruction_one")}</p>
                <p className='mb-0'>- {t("change_password_instruction_two")}</p>
                <p className='mb-0'>- {t("change_password_instruction_three")}</p>
              </div>
            </div>
            <div className='flex flex-col'>
              <div className="relative flex flex-col mt-8">
                <input className={'w-full placeholder-gray-800 p-2 rounded-xl focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'}
                  type={isPasswordHidden ? 'password' : 'text'}
                  ref={register({ required: true, pattern: regex, minLength: 6, maxLength: 14 })}
                  placeholder="Contraseña"
                  name="password"
                />
                <ShowPassword
                  isPasswordHidden={isPasswordHidden}
                  setIsPasswordHidden={setIsPasswordHidden}
                />
              </div>
              {errors.password && errors.password.type === "required" && <span className="text-red-600">{t("required_information")}</span>}
              {errors.password && errors.password.type === "pattern" && <span className="text-red-600">{t("change_password_not_comply")}</span>}
              {errors.password && errors.password.type === "minLength" && <span className="text-red-600">{t("change_password_minimum_six_characters")}</span>}
              {errors.password && errors.password.type === "maxLength" && <span className="text-red-600">{t("change_password_maximum_fourteen_characters")}</span>}
              <div className="relative flex flex-col mt-8">
                <input className={'w-full placeholder-gray-800 p-2 rounded-xl focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'}
                  type={isPasswordConfirmHidden ? 'password' : 'text'}
                  ref={register({ required: true })}
                  placeholder="Confirme contraseña"
                  name="confirmPassword"
                  onChange={comparePassword}
                />
                <ShowPassword
                  isPasswordHidden={isPasswordConfirmHidden}
                  setIsPasswordHidden={setIsPasswordConfirmHidden}
                />
              </div>
              {errors.confirmPassword && errors.confirmPassword.type === "required" && <span className="text-red-600">{t("required_information")}</span>}
              {!comparePass && <span className="text-red-600">{t("change_password_passwords_donot_match")}</span>}
            </div>
            <div className='flex w-full justify-center h-[35px] mt-10'>
              <button type=" submit" className="btn shadow-lg btn-block w-[70%] bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                {t("change_password_reset_pass")}
              </button>
            </div>
          </form>
        }
      </div>
      <div className="absolute bottom-8 right-11 md:right-8 text-white">
        <div className="flex items-center space-x-4 md:space-x-8">
          <img src={logo} alt='Rolf Wittmer Logo' className='w-[150px] md:w-[180px] mt-3' />
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;